import { createContext } from "react";

const PrivillageMasterContext = createContext({});

export default PrivillageMasterContext;
